import Form from '@gef-ui/form-material/Form';

import formDescriptorFn, { CONTACT_HISTORY_FORM_NAME } from 'features/views/contactHistory/form';

import Filter from './Filter';

export const CommunicationOverview = () => (
	<Form name={CONTACT_HISTORY_FORM_NAME} formDescriptorFn={formDescriptorFn}>
		<Filter />
	</Form>
);

export default CommunicationOverview;
